import classNames from 'classnames';
import React from 'react';
import type { Accept } from 'react-dropzone';
import { useDropzone } from 'react-dropzone';
import * as styles from './ImageEditorDropZone.module.scss';
import SVGIcon from './SVGIcon';
import imageIcon from '../icons/non-prefilled/28x28/dropzoneImage.svg';

interface ImageEditorDropZoneProps {
  onDropImage(file: File): void;
  children: React.ReactNode;
  disabled?: boolean;
  accept: Accept;
}

const ImageEditorDropZone = ({
  onDropImage,
  children,
  disabled,
  accept,
}: ImageEditorDropZoneProps) => {
  const { getRootProps, isDragAccept } = useDropzone({
    accept,
    multiple: false,
    maxSize: 25 * 1000 * 1000,
    disabled,
    onDrop([file]) {
      if (file) {
        onDropImage(file);
      }
    },
  });

  return (
    <div
      {...getRootProps()}
      className={classNames(styles.container, {
        [styles.isHidden]: !isDragAccept,
      })}
    >
      <div className={styles.dropZone}>
        <SVGIcon className={styles.dropZoneIcon} size={28}>
          {imageIcon}
        </SVGIcon>
        <div>Drop an image to upload</div>
      </div>
      {children}
    </div>
  );
};

export default ImageEditorDropZone;
